const howlerIntegration = require("./howler_integration");
let mute = true;

const soundsMiddleware = (soundsData) => {
	howlerIntegration.initialize(soundsData);
	
	return store => next => action => {
		// Ignore actions that haven't specified a sound.
		
		if (!action.meta) {
			return next(action);
		}
		const soundName = action.meta.sound || undefined;
		const playType = action.meta.op;
		const channel = action.meta.channel;
		switch (playType) {
			case "playFx":
				howlerIntegration.playfx(soundName);
				break;
			case "stopVoice":
				howlerIntegration.stopVoice(soundName, 'voice');
				break;
			case "mute":
				mute = !mute;
				howlerIntegration.muteAudio(mute);
				store.dispatch({
					type: "SET_MUTE", 
			 		mute: mute
				})
				break;
			case "channelStop":
				howlerIntegration.channelStop(soundName);
				break;
			case "stop":
				howlerIntegration.stop(soundName);
				break;
			case "fade":
				howlerIntegration.fade(soundName, channel);
				break;	
			default:
				howlerIntegration.play(soundName, channel);
		}

		return next(action);
	};
}

export default soundsMiddleware;



// WEBPACK FOOTER //
// ./src/middleware/soundsMiddleware.js